export const sliderItems = [
  {
    id: 1,
    img: 'https://images.pexels.com/photos/5632399/pexels-photo-5632399.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    title: 'BLACK FRIDAY SALE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: 'f5fafd'
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/7249346/pexels-photo-7249346.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    title: 'AUTUMN COLLECTION',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 50% OFF FOR NEW ARRIVALS.",
    bg: 'fcf1ed'
  },
  {
    id: 3,
    img: 'https://images.pexels.com/photos/6599308/pexels-photo-6599308.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    title: 'LOUNGEWEAR LOVE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 70% OFF FOR NEW ARRIVALS.",
    bg: 'fbf0f4'
  }
];

export const categories = [
  {
    id: 1,
    img: 'https://images.pexels.com/photos/2292953/pexels-photo-2292953.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    title: 'SHIRT STYLE!',
    cat: 'women'
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    title: 'LOUNGEWEAR LOVE',
    cat: 'men'
  },
  {
    id: 3,
    img: 'https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    title: 'LIGHT JACKETS',
    cat: 'jeans'
  },
  {
    id: 4,
    img: 'https://images.pexels.com/photos/2129918/pexels-photo-2129918.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    title: 'MEDIUM JACKETS',
    cat: 'coat'
  }
];

export const popularProducts = [
  {
    id: 1,
    img: 'https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png'
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/6045058/pexels-photo-6045058.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'
  },
  {
    id: 3,
    img: 'https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png'
  },
  {
    id: 4,
    img: 'https://images.pexels.com/photos/904350/pexels-photo-904350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260'
  },
  {
    id: 5,
    img: 'https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png'
  },
  {
    id: 6,
    img: 'https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png'
  },
  {
    id: 7,
    img: 'https://images.pexels.com/photos/10812162/pexels-photo-10812162.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'
  },
  {
    id: 8,
    img: 'https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png'
  }
];
